import React, { useState, useEffect, useRef } from 'react';
import {
  Container, Typography, Button, Box, Grid, Modal, IconButton, TextField, Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  PaginationItem,
  Pagination,
  Stack,
  Popover,
  InputAdornment,
  Divider,
  Chip,
  Breadcrumbs,
} from '@mui/material';
import { handleSpaces, getErrorMessage, functiondisable, functionenable } from "../utils/helper.js";
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
import { ReactComponent as SearchIcon } from "../assets/images/new-search-gray-icon.svg";
import { danger, success } from '../utils/message-box.js';
import InfoIcon from "@mui/icons-material/Info";
import axiosInstance from '../Services/axiosInstance.js';
import { getVendorDisplayName } from '../utils/auth.js';
import moment, { duration } from "moment";
import noCandidate from "../assets/images/Nomatching candidates.png";
import { ReactComponent as ArrowBackIcon } from "../assets/images/arrow-left.svg";
import { ReactComponent as ArrowForwardIcon } from "../assets/images/arrow-right.svg";
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import CloseIcon from "@mui/icons-material/Close";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import '../assets/styles/stylesheets/daterangepicker.css';
import ClearIcon from "@mui/icons-material/Clear";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { ReactComponent as BacktoJob } from "../assets/images/back-to-jobs-black.svg";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));
const GuestUserScreen = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const inputRef = React.useRef();
  const [uploadModal, setUploadModal] = useState(false);
  const [filename, setFilename] = useState("");
  const [extension, setExtension] = useState("");
  const [pictureFile, setPictureFile] = useState(null);
  const [skills, setSkills] = useState([]);
  const [openSnackbar, setOpenSnakbar] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [currentPage, setCurrentpage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [firstTimeLoad, setFirstTimeLoad] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [anchor, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [errorStatus, setErrorStatus] = useState();
  const [candidates, setCandidates] = useState([]);
  const [walletAmount, setWalletAmount] = useState(0);
  const [duplicateNumber, setDuplicateNumber] = useState("");
  const [invalidMobilePhoneError, setInvalidMobilePhoneError] = useState("");
  const [previouslySearchedKeyword, setPreviouslySearchedKeyword] = useState("");
  const id = open ? "simple-popover" : undefined;
  const [dateRange, setDateRange] = useState({ start: moment().subtract(29, 'days'), end: moment() });
  const { start, end } = dateRange;
  const [dateFilter, setDateFilter] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const label = start.format('MMM D, YYYY') + ' - ' + end.format('MMM D, YYYY');
  // base URL handled by axiosInstance
  const columns = [
    { col: "Status", key: "order_status", width: "150px" },
    { col: "Order Date", key: "created_at", width: "120px" },
    { col: "Barcode", key: "barcode", width: "120px" },
    { col: "Phone Number", key: "phone_number", width: "120px" },
    { col: "Alt Phone", key: "alt_phone_number", width: "120px" },
    { col: "Pincode", key: "pincode", width: "80px" },
    { col: "Address", key: "address", width: "120px" },
    { col: "Size Details", key: "size_details", width: "150px" },
    { col: "Qantity", key: "order_quantity", width: "80px" },
    { col: "Commission", key: "commision", width: "80px" },
    { col: "Payment Status", key: "payment_status", width: "80px" },
    { col: "COD", key: "cod", width: "80px" },
    { col: "Prepaid", key: "prepaid", width: "80px" },
    { col: "Weight", key: "weight", width: "120px" },
    { col: "Created By", key: "created_by", width: "80px" },
  ];
  const handleChangePage = (event, newPage) => {
    setCurrentpage(newPage);
    setFirstTimeLoad(true);
    getCustomers(newPage);
  };
  const handleClosePopover = () => {
    setOpen(false);
    functionenable();
  };
  function getTotalQuantity(items) {
    return items.reduce((total, item) => total + item.quantity, 0);
  };
  const handleClick = (e, skills) => {
    setSkills(skills);
    setAnchorEl(e.currentTarget);
    setOpen(true);
    functiondisable();
  };
  const getOrderCommissionDisplay = (order) => {
    if (order?.payment_status === 'Done') {
      return '-';
    }

    const orderStatus = order?.order_status;
    if (orderStatus === 'Delivered' || orderStatus === 'Dispatched' || orderStatus === 'Returned') {
      return order?.commision ?? 0;
    }

    return '-';
  };

  const normalizeSearchQuery = (value) => {
    if (!value) return '';
    return value.charAt(0) === '#' ? value.split('#')[1] : value;
  };

  const buildCustomerFetchParams = (newPage, options = {}) => {
    const params = {
      page: newPage ?? currentPage,
      page_size: 10,
    };

    const activeQuery = options.searchValue ?? (previouslySearchedKeyword || searchKeyword);
    const query = normalizeSearchQuery(activeQuery);
    if (query) {
      params.query = query;
    }

    const useDateFilter = options.dateFilter ?? dateFilter;
    const rangeStart = options.start ?? start;
    const rangeEnd = options.end ?? end;
    if (useDateFilter) {
      params.start_date = rangeStart.format('YYYY-MM-DD');
      params.end_date = rangeEnd.format('YYYY-MM-DD');
    }

    return params;
  };

  const resolveWalletAmount = (responseData) =>
    responseData?.vendor_wallet_balance
    ?? responseData?.total_commission
    ?? 0;

  const getCustomers = (newPage, options = {}) => {
    setFirstTimeLoad(true);
    axiosInstance.get('/api/v1/vendor/orders', {
      params: buildCustomerFetchParams(newPage, options),
    })
      .then((res) => {
        setCurrentpage(res.data.data.currentPage);
        setCandidates(res.data.data.data);
        setTotalCount(res.data.data.totalCount);
        setWalletAmount(resolveWalletAmount(res.data.data));
        setFirstTimeLoad(false);
      })
      .catch(function (error) {
        setErrorStatus();
        setDuplicateNumber("");
        setFirstTimeLoad(false);
        danger(getErrorMessage(error, 'Failed to load orders.'));
      });
  };
  useEffect(() => {
    setCurrentpage(1);
    setPreviouslySearchedKeyword('');
    setSearchKeyword('');
    getCustomers(1);
  }, []);
  const handleCallback = (rangeStart, rangeEnd) => {
    setDateRange({ start: rangeStart, end: rangeEnd });
    setDateFilter(true);
    const params = buildCustomerFetchParams(1, {
      dateFilter: true,
      start: rangeStart,
      end: rangeEnd,
    });
    axiosInstance.get('/api/v1/vendor/orders', { params })
      .then((res) => {
        setCurrentpage(1);
        setCandidates(res.data.data.data);
        setTotalCount(res.data.data.totalCount);
        setWalletAmount(resolveWalletAmount(res.data.data));
      }).catch((e) => {
        danger(getErrorMessage(e, 'Failed to load customers. Please try again.'));
      });
  };
  const handleClickOnCancel = (event, picker) => {
    setDateRange({ start: moment().subtract(29, 'days'), end: moment() });
    setDateFilter(false);
  };
  const search = (e) => {
    setFirstTimeLoad(true);
    const searchValue =
      e?.type === "input" && e?.target?.value === "" ? "" : searchKeyword;
    const params = buildCustomerFetchParams(1, { searchValue });
    if (!searchValue) {
      delete params.query;
    }

    axiosInstance.get('/api/v1/vendor/orders', { params })
      .then((res) => {
        setCurrentpage(1);
        setPreviouslySearchedKeyword(searchValue);
        setSearchKeyword(searchValue);
        setCandidates(res.data.data.data);
        setTotalCount(res.data.data.totalCount);
        setWalletAmount(resolveWalletAmount(res.data.data));
        setFirstTimeLoad(false);
      })
      .catch(function (error) {
        setErrorStatus();
        setDuplicateNumber("");
        setFirstTimeLoad(false);
        danger(getErrorMessage(error, 'Failed to search orders.'));
      });
  }
  const handleEnterKey = (e) => {
    setSearchKeyword(e.target.value);
    if (
      e.key === "Enter" &&
      e.target.value !== "" &&
      e.target.value !== previouslySearchedKeyword
    ) {
      e.preventDefault();
      search();
    }
    if (
      e.type === "input" &&
      e.target.value === "" &&
      previouslySearchedKeyword !== ""
    ) {
      e.preventDefault();
      search(e);
    }
  };
  return (
    <>
      <Container
        maxWidth="lg"
        className="guest-user-screen"
        sx={{
          px: { xs: 2, sm: 3 },
          py: { xs: 2, md: 3 },
          mt: { xs: 1, md: 2 },
          maxWidth: '100%',
          overflowX: 'hidden',
        }}
      >
        <Box sx={{ mb: 3 }}>
        <Typography>
              <Breadcrumbs
                aria-label="breadcrumb"
                className="pt-0 pb-10"
                separator={<NavigateNextIcon fontSize="small" aria-label="Next icon" />}
              >
                <span className="cursor-hover d-flex f-12 gray9 font-weight-600 text-decoration-none" onClick={() => navigate('/vendor/home')}>
                  <BacktoJob className="mr-10" />
                  Back to Home
                </span>
                {/* </Link> */}
              </Breadcrumbs>
            </Typography>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              fontSize: { xs: '1.35rem', sm: '1.5rem' },
              color: '#101828',
            }}
          >
            My Orders
          </Typography>
          <Typography sx={{ mt: 0.5, color: '#667085', fontSize: '0.9rem' }}>
            {getVendorDisplayName()} — review and search your orders below.
          </Typography>
        </Box>

        <Paper
          elevation={0}
          sx={{
            border: '1px solid #EAECF0',
            borderRadius: '12px',
            p: { xs: 2, sm: 2.5 },
            mb: 2,
          }}
        >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={7}>
                <TextField
                  inputRef={inputRef}
                  name="searchKeyword"
                  type="text"
                  fullWidth
                  size="small"
                  className="inputcontrasts position-issue postJob-search search-id w-100 new-search textEllipse-talent-search"
                  variant="outlined"
                  placeholder="Search by name, phone number, or order ID"
                  onKeyPress={(e) => {
                    handleSpaces(e);
                    handleEnterKey(e);
                  }}
                  onInput={handleEnterKey}
                  onKeyDown={handleEnterKey}
                  value={searchKeyword}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon width="18px" aria-label="search icon" />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        {searchKeyword !== '' && (
                          <ClearIcon
                            onClick={() => {
                              setSearchKeyword('');
                              setPreviouslySearchedKeyword('');
                              setCurrentpage(1);
                              getCustomers(1, { searchValue: '' });
                            }}
                            style={{ marginRight: '5px' }}
                            aria-label="Clear icon"
                            className="cursor-hover"
                          />
                        )}
                        <Typography className="search-byId">
                          <Grid
                            className="border-radius-6 d-flex align-center cursor-hover"
                            style={{ padding: '8px 4px 8px 0' }}
                            onClick={() => {
                              if (
                                searchKeyword !== '' &&
                                searchKeyword !== previouslySearchedKeyword
                              ) {
                                search();
                              }
                            }}
                            aria-label="Search icon"
                            disableRipple="true"
                          >
                            <SearchIcon width="18px" aria-label="search icon" />
                          </Grid>
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': { borderRadius: '8px' },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={5}>
                <Box
                  className="bluk-upload-daterangepicker guest-orders-date-range-wrap"
                  sx={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    '& > div': {
                      width: '100%',
                    },
                    '& #reportrange': {
                      width: '100%',
                      minHeight: 35,
                      height: 35,
                      boxSizing: 'border-box',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      gap: 1,
                      margin: '0 !important',
                      padding: '0 12px !important',
                      borderRadius: '8px',
                      border: '1px solid #98A2B3 !important',
                      background: '#fff',
                      color: '#344054',
                      cursor: 'pointer',
                      fontSize: isMobile ? '0.8125rem' : '0.875rem',
                      lineHeight: 1.2,
                      '& .guest-orders-date-label': {
                        flex: 1,
                        minWidth: 0,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                      },
                      '&.chip-dropdown-active': {
                        borderColor: 'var(--primary-color)',
                        backgroundColor: 'var(--primary-color) !important',
                        padding: '0 12px !important',
                        height: 40,
                        minHeight: 40,
                        '& .guest-orders-date-label': {
                          color: '#fff',
                        },
                      },
                    },
                  }}
                >
                  <DateRangePicker
                    initialSettings={{
                      startDate: start.toDate(),
                      endDate: end.toDate(),
                      ranges: {
                        Today: [moment().toDate(), moment().toDate()],
                        Yesterday: [
                          moment().subtract(1, 'days').toDate(),
                          moment().subtract(1, 'days').toDate(),
                        ],
                        'Last 7 Days': [
                          moment().subtract(6, 'days').toDate(),
                          moment().toDate(),
                        ],
                        'Last 30 Days': [
                          moment().subtract(29, 'days').toDate(),
                          moment().toDate(),
                        ],
                        'This Month': [
                          moment().startOf('month').toDate(),
                          moment().endOf('month').toDate(),
                        ],
                        'Last Month': [
                          moment().subtract(1, 'month').startOf('month').toDate(),
                          moment().subtract(1, 'month').endOf('month').toDate(),
                        ],
                      },
                    }}
                    onCallback={handleCallback}
                    onCancel={handleClickOnCancel}
                  >
                    <div
                      id="reportrange"
                      className={dateFilter ? 'chip-dropdown-active margin-0' : 'margin-0'}
                    >
                      <i className="fa fa-calendar" aria-hidden="true" />
                      <span className="guest-orders-date-label">{label}</span>
                      <i className="fa fa-caret-down" aria-hidden="true" />
                    </div>
                  </DateRangePicker>
                </Box>
              </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                alignItems: { xs: 'stretch', sm: 'center' },
                justifyContent: 'space-between',
                gap: 1.5,
              }}
            >
              <Typography sx={{ color: '#667085', fontSize: '0.875rem' }}>
                Showing {candidates.length} of {totalCount} order{totalCount !== 1 ? 's' : ''}
              </Typography>
              {/* <Chip
                icon={<AccountBalanceWalletIcon sx={{ fontSize: '18px !important' }} />}
                label={`Wallet Amount: ₹${Number(walletAmount).toLocaleString('en-IN')}`}
                sx={{
                  alignSelf: { xs: 'stretch', sm: 'flex-end' },
                  justifyContent: { xs: 'center', sm: 'flex-start' },
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  py: 2.25,
                  px: 0.5,
                  borderRadius: '8px',
                  backgroundColor: Number(walletAmount) < 0 ? '#FEF3F2' : '#ECFDF3',
                  color: Number(walletAmount) < 0 ? '#B42318' : '#027A48',
                  border: Number(walletAmount) < 0 ? '1px solid #FECDCA' : '1px solid #ABEFC6',
                  '& .MuiChip-icon': {
                    color: Number(walletAmount) < 0 ? '#B42318' : '#027A48',
                  },
                }}
              /> */}
            </Box>
          </Paper>
      </Container>
      <Grid sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
        {firstTimeLoad ? (
          <>
            <div className="mt-24">
              {[...Array(12)].map((e, i) => (
                <Typography className="display-flex align-center" key={i}>
                  <div className="lazy-loader">
                    <div className="">
                      <Grid container spacing={1} className="">
                        <Grid className="shimmerBG img mx-8 px-8"></Grid>
                        <Grid
                          lg={2}
                          md={2}
                          xs={2}
                          className="shimmerBG title-line mx-8 px-8"
                        ></Grid>
                        <Grid
                          lg={1.5}
                          md={2}
                          xs={2}
                          className="shimmerBG title-line mx-8 px-8"
                        ></Grid>
                        <Grid
                          lg={1.5}
                          md={2}
                          xs={2}
                          className="shimmerBG title-line mx-8 px-8"
                        ></Grid>
                        <Grid
                          lg={1.5}
                          md={2}
                          xs={2}
                          className="shimmerBG title-line mx-8 px-8"
                        ></Grid>
                        <Grid
                          lg={1}
                          md={2}
                          xs={2}
                          className="shimmerBG title-line mx-8 px-8"
                        ></Grid>
                        <Grid
                          lg={1}
                          md={2}
                          xs={2}
                          className="shimmerBG title-line mx-8 px-8"
                        ></Grid>
                        <Grid
                          lg={1}
                          md={2}
                          xs={2}
                          className="shimmerBG title-line mx-8 px-8"
                        ></Grid>
                      </Grid>
                      <Grid container spacing={1}>
                        <Grid
                          lg={0.5}
                          md={2}
                          xs={2}
                          className="shimmerBG title-line mx-8 px-8"
                        ></Grid>
                        <Grid
                          lg={1.5}
                          md={2}
                          xs={2}
                          className="shimmerBG title-line mx-8 px-8"
                        ></Grid>
                        <Grid></Grid>
                        <Grid></Grid>
                        <Grid></Grid>
                        <Grid></Grid>
                      </Grid>
                    </div>
                  </div>
                </Typography>
              ))}
            </div>
          </>
        ) : (
          <Grid className="matching-view" id="talent-console-candidates">
            {/* {isLoading && <Loader />} */}
            <Typography>
              <>
                {candidates?.length > 0 ? (
                  <Grid
                    container
                    item
                    className="mt-15 matching-list-view ipad-view-align"
                    sx={{ mx: 0, width: '100%' }}
                  >
                    <TableContainer
                      component={Paper}
                      className="no-table-border testing table-container table-list-align matching-list-align"
                      sx={{
                        width: '100%',
                        overflowX: 'auto',
                        WebkitOverflowScrolling: 'touch',
                        borderRadius: '12px',
                        border: '1px solid #EAECF0',
                      }}
                    >
                      <Table
                        aria-label="simple table"
                        className="matching-table pl-10 pr-10"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell
                              key="Candidate Details"
                              align="left"
                              style={{ minWidth: "130px" }}
                              className="title-align align-center table-position"
                              sx={{ position: 'sticky', left: 0, backgroundColor: '#F2F4F7', zIndex: 1 }}
                            >Customer Name</TableCell>
                            {columns.map((C, index) => (
                              <TableCell
                                align="left"
                                className="vertical-align-top"
                                style={{ minWidth: C.width }}
                                key={index}
                              >
                                {C.col}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody className="bg-white">
                          {candidates?.map((candidate, index) => (
                            <>
                              <TableRow
                                key={index}
                                className="cursor-hover"
                                hover
                              >
                                <TableCell
                                  align="left"
                                  sx={{ position: 'sticky', left: 0, zIndex: 1 }}
                                  className="list-matching table-position"
                                >{candidate.name}</TableCell>
                                {columns?.map((C, index) => (
                                  <TableCell
                                    key={index}
                                    align="left"
                                  >
                                    <Typography className="gray10 font-weight-400 f-14 mt-4">
                                      {C.key == 'remarks' ? (candidate[C.key] != null && candidate[C.key].startsWith("CM") ? Number(candidate[C.key].substring(2)) : 0) : C.key == 'order_quantity' ? (candidate[C.key] ? candidate[C.key] : getTotalQuantity(candidate["size_details"])) : C.key == 'address' ? <BootstrapTooltip title={candidate[C.key]} placement="top"><span className="textEllipse" style={{ width: C.width }}>{candidate[C.key]}</span></ BootstrapTooltip> : C.key == 'payment_status' ? (candidate[C.key] ? <span className="availableStatus">{candidate[C.key]}</span> : "-") : C.key == 'order_status' ? <span className={`${candidate[C.key] == "Returned" ? 'expiryStatus' : candidate[C.key] == "Delivered" ? 'availableStatus' : candidate[C.key] == "In-transit" ? 'declineStatus' : candidate[C.key] == "Dispatched" ? 'dispatchStatus' : candidate[C.key] == "Pending" ? 'pendingStatus' : 'complaintStatus'}`}>
                                        {candidate[C.key] ? candidate[C.key] : '-'}
                                      </span> : C.key == "size_details" ? <Box className="candidate-skills">
                                        {candidate[C.key].map(
                                          (skills, index) => {
                                            return index < 1 ? (
                                              <span
                                                key={index}
                                                className="skills text-initial"
                                              >
                                                {skills.product_type}-{skills.size} ({skills.quantity})
                                              </span>
                                            ) : null;
                                          }
                                        )}
                                        {candidate[C.key].length >
                                          1 && (
                                            <Box
                                              style={{
                                                display: "inline-flex",
                                              }}
                                            >
                                              <span
                                                className="cursor-hover link-color font-weight-600 f-12 pl-5"
                                                onClick={(e) =>
                                                  handleClick(e, candidate[C.key])
                                                }
                                              >{`+${candidate[C.key]
                                                .length - 1
                                                } more`}</span>
                                            </Box>
                                          )}
                                      </Box> : C.key == 'created_at' ? (candidate[C.key] ? moment(candidate[C.key]).format('YYYY-MM-DD') : '-') : C.key == 'commision' ? getOrderCommissionDisplay(candidate) : ((C.key == 'cod' || C.key == 'received_cod_amount' || C.key == 'delivary_charges' || C.key == 'prepaid') && candidate[C.key] == 0) ? 0 : candidate[C.key] ? candidate[C.key] : '-'}
                                    </Typography>
                                  </TableCell>
                                ))}
                              </TableRow>
                            </>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {candidates?.length !== 0 && (
                      <>
                        {" "}
                        <Grid
                          container
                          item
                          spacing={1}
                          className="align-between align-center pagenation-design mt-15 pb-20 galaxy-margin-0"
                          sx={{ width: '100%', mx: 0 }}
                        >
                          {totalCount > 10 && (
                            <>
                              <Grid
                                item
                                lg={6}
                                md={6}
                                xs={12}
                                className="pagenation-table pt-5 galaxy-padding-left-0"
                              >
                                <Typography className="d-flex f-14 align-center font-weight-500 galaxy-block  gal-slot-align">
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                lg={6}
                                md={6}
                                xs={12}
                                className="justify-end d-flex pagenation-table navbarUser pt-5 galaxy-padding-left-0"
                              >
                                <Stack
                                  spacing={2}
                                  className="pagenation-joblist"
                                >
                                  <Pagination
                                    shape="rounded"
                                    className="position-issue"
                                    // color="primary"
                                    rowsperpage={10}
                                    count={
                                      Math.floor(totalCount / 10) +
                                      (totalCount % 10 === 0 ? 0 : 1)
                                    }
                                    page={currentPage}
                                    onChange={handleChangePage}
                                    renderItem={(item) => (
                                      <PaginationItem
                                        components={{
                                          last: (props) => (
                                            <button
                                              className="btn primary-button profileButton"
                                              aria-label="button"
                                              {...props}
                                            >
                                              Last
                                            </button>
                                          ),

                                          next: (props) => (
                                            <Box
                                              className="d-flex align-center cursor-hover"
                                              {...props}
                                            >
                                              <Box className="gray7 f-14 align-center font-weight-500 ml-10 mr-20">
                                                Next
                                              </Box>
                                              <ArrowForwardIcon
                                                height="13px"
                                                width="13px"
                                              />{" "}
                                            </Box>
                                          ),

                                          first: (props) => (
                                            <Box
                                              className="d-flex align-center cursor-hover"
                                              {...props}
                                            >
                                              <ArrowBackIcon
                                                height="13px"
                                                width="13px"
                                              />{" "}
                                              <Box className="gray7 f-14 align-center font-weight-500 ml-10 mr-15">
                                                Previous
                                              </Box>
                                            </Box>
                                          ),

                                          previous: (props) => (
                                            <Box
                                              className="d-flex align-center cursor-hover"
                                              {...props}
                                            >
                                              <ArrowBackIcon
                                                height="13px"
                                                width="13px"
                                              />{" "}
                                              <Box className="gray7 f-14 font-weight-500 ml-10 mr-15">
                                                Previous
                                              </Box>
                                            </Box>
                                          ),
                                        }}
                                        {...item}
                                      />
                                    )}
                                    showFirstButton={false}
                                    showLastButton={false}
                                  />
                                </Stack>
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </>
                    )}
                  </Grid>
                ) : (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      py: { xs: 4, md: 6 },
                      px: 2,
                      textAlign: 'center',
                    }}
                  >
                    <Box
                      component="img"
                      src={noCandidate}
                      alt="No orders found"
                      sx={{
                        width: { xs: 180, sm: 230 },
                        height: 'auto',
                        maxWidth: '100%',
                      }}
                    />
                    <Typography
                      className="gray9 f-16 font-weight-700"
                      sx={{ mt: 2, fontSize: { xs: '1rem', sm: '1.125rem' } }}
                    >
                      No data found
                    </Typography>
                    <Typography sx={{ mt: 1, color: '#667085', fontSize: '0.875rem', maxWidth: 360 }}>
                      No orders match your filters. Try a different search or create a new order.
                    </Typography>
                  </Box>
                )}
              </>
            </Typography>
          </Grid>
        )}
      </Grid>
      <Popover
        id={id}
        open={open}
        anchorEl={anchor}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "-500",
          horizontal: "200",
        }}
        anchorPosition={{
          left: 500,
        }}
        transformOrigin={{
          vertical: "300",
          horizontal: "200",
        }}
      >
        <Grid item sx={{ p: 1 }}>
          <Box className="align-between">
            <Grid item xs={12} md={12}>
              <Typography
                id="modal-title"
                className="d-flex align-between p-10"
              >
                <Typography variant="h5" className="f-16 font-weight-600 heading-text-color">
                  Size Details
                </Typography>
                <Typography
                  align="right"
                  className="cursor-hover gray7 icon-button"
                >
                  <CloseIcon
                    onClick={handleClosePopover}
                    onKeyPress={handleClosePopover}
                    aria-label="Close icon"
                  />
                </Typography>
              </Typography>
            </Grid>
          </Box>
          <Grid
            item
            className="p-10"
            style={{ maxHeight: "250px", overflow: "auto", maxWidth: "300px" }}
          >
            <Box>
              {skills.map((skill, index) => {
                return (
                  <span key={index} className="skills">
                    {skill.product_type}-{skill.size} ({skill.quantity})
                  </span>
                );
              })}
            </Box>
          </Grid>
        </Grid>
      </Popover>
    </>
  );
};

export default GuestUserScreen;
